
<div class="container">
    <mat-spinner [diameter]="50" ></mat-spinner>
    <p>{{ data.txt }}</p>
</div>

